import React from "react";

export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="border-b border-gray-200 bg-white">
      <div className="px-8 py-6 flex items-start justify-between gap-4">
        <div>
          {subtitle && <div className="label-caps mb-1">{subtitle}</div>}
          <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tight leading-none text-gray-900">
            {title}
          </h1>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
